export default __webpack_public_path__ + "static/media/partner1.ba75cd19.jpg";